import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'footer',
    templateUrl: 'footer.html',
})
export class FooterComponent {
    private year: number
    public copyright: string
    constructor() {
        this.year = (new Date()).getFullYear();
        this.copyright = `© ${this.year} Inmar Inc.` ;
    }

}



// WEBPACK FOOTER //
// ./src/app/components/footer/footer.component.ts